import React, { useMemo, useEffect, useCallback } from 'react';
import useTheme from 'branding/theme';
import SplashView from '../SplashView';
import XButton from '../../inputs/XButton';
import CircularButton from '../../inputs/CircularButton';
import XIcon from '../../icons/utility/XIcon';
import useToggle from '../../hooks/useToggle';
import useComponentMargin from '../../hooks/useComponentMargin';
import useCloseOnEsc from './useCloseOnEsc';
const ModalWrapper = ({ className, children, isCancelable = false, isDrawer = false, closePosition = 'inside', 
/** externalControls explained in components/Takeover */
externalControls = [], onClose, type, hideLogo, noDefaultPadding, innerSectionStyles, splashPadding, xClassname
// eslint-disable-next-line sonarjs/cognitive-complexity
 }) => {
    const [externalState, setExternalState] = externalControls;
    const usesExternalState = externalState !== undefined;
    const [isOpen, handleOpen, handleInternalClose] = useToggle(usesExternalState ? externalState : true);
    const show = externalState !== undefined ? externalState : isOpen;
    const handleClose = useCallback(() => {
        handleInternalClose();
        onClose && onClose();
        setExternalState && setExternalState(false);
    }, [handleInternalClose, onClose, setExternalState]);
    const { isWebView, sizing: { component: { margin } } } = useTheme();
    const xIconMargin = useComponentMargin({
        marginTop: isWebView ? 'large' : 'regular',
        marginRight: type === 'modal' ? 'regular' : 'large'
    });
    const xIconStyles = useMemo(() => ({
        ...xIconMargin,
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1
    }), [xIconMargin]);
    const outsideCloseStyles = useMemo(() => ({
        position: 'absolute',
        right: `-${margin.large}`,
        top: `-${margin.large}`,
        zIndex: 1
    }), [margin]);
    useEffect(() => {
        if (usesExternalState) {
            externalState ? handleOpen() : handleInternalClose();
        }
    }, [usesExternalState, externalState, handleInternalClose, handleOpen]);
    useCloseOnEsc(isOpen, isCancelable, handleClose);
    return (React.createElement(SplashView, { className: className, type: type, hideLogo: hideLogo, noDefaultPadding: noDefaultPadding, innerSectionStyles: innerSectionStyles, isModal: true, isOpenModal: show, splashPadding: splashPadding, isCancelable: isCancelable, handleClose: handleClose, isDrawer: isDrawer },
        isCancelable &&
            (closePosition === 'outside' ? (React.createElement(CircularButton, { alt: "close", onClick: handleClose, className: xClassname, styles: outsideCloseStyles },
                React.createElement(XIcon, { type: "inverted", size: "small" }))) : (React.createElement(XButton, { alt: "close", onClick: handleClose, className: xClassname, styles: xIconStyles }))),
        children(handleClose)));
};
export default ModalWrapper;
//# sourceMappingURL=index.js.map